// 2026-06-25: Phase 12 — Machine type icons (inline SVG, scales crisp at any size)
// One technical-style illustration per machine type.

import React from 'react';

// Default sized to fit a 56x56 thumbnail; override with style/className if needed.
export function MachineIcon({ type, size = 56, color = '#374151' }) {
  const t = (type || 'OTHER').toUpperCase();
  const props = { width: size, height: size, viewBox: '0 0 64 64', xmlns: 'http://www.w3.org/2000/svg' };
  const c = color;
  switch (t) {
    case 'VMC':
      // Vertical Machining Center — gantry over table
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="10" y="38" width="44" height="10" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <rect x="14" y="14" width="36" height="6" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <line x1="18" y1="14" x2="18" y2="44" stroke={c} strokeWidth="2"/>
          <line x1="46" y1="14" x2="46" y2="44" stroke={c} strokeWidth="2"/>
          <rect x="28" y="6" width="8" height="14" rx="1" fill={c}/>
          <rect x="29" y="20" width="6" height="14" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <circle cx="32" cy="36" r="2" fill={c}/>
        </svg>
      );
    case 'HMC':
      // Horizontal Machining Center — horizontal spindle with pallet
      return (
        <svg {...props}>
          <rect x="4" y="48" width="56" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="6" y="20" width="20" height="28" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <rect x="40" y="14" width="20" height="34" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <rect x="26" y="28" width="14" height="6" fill={c}/>
          <circle cx="40" cy="31" r="3" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <line x1="40" y1="31" x2="46" y2="31" stroke={c} strokeWidth="2"/>
          <rect x="46" y="38" width="12" height="8" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
        </svg>
      );
    case 'VTL':
      // Vertical Turret Lathe — vertical chuck facing up
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="14" y="34" width="36" height="14" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <circle cx="32" cy="30" r="14" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <circle cx="32" cy="30" r="9" fill="#fff" stroke={c} strokeWidth="1.5"/>
          <line x1="32" y1="16" x2="32" y2="44" stroke={c} strokeWidth="1.5" strokeDasharray="2 2"/>
          <line x1="18" y1="30" x2="46" y2="30" stroke={c} strokeWidth="1.5" strokeDasharray="2 2"/>
          <rect x="44" y="6" width="6" height="14" fill={c}/>
        </svg>
      );
    case 'TC':
      // Turning Center / Lathe — horizontal chuck with tool turret
      return (
        <svg {...props}>
          <rect x="4" y="48" width="56" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="4" y="20" width="56" height="28" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <circle cx="14" cy="34" r="10" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <circle cx="14" cy="34" r="5" fill="#fff" stroke={c} strokeWidth="1.5"/>
          <rect x="24" y="32" width="22" height="4" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <polygon points="46,28 52,32 46,36" fill={c}/>
          <circle cx="52" cy="22" r="5" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <line x1="52" y1="17" x2="52" y2="27" stroke={c} strokeWidth="1"/>
          <line x1="47" y1="22" x2="57" y2="22" stroke={c} strokeWidth="1"/>
        </svg>
      );
    case 'TMC':
      // Turn-Mill Center — chuck + mill spindle combined
      return (
        <svg {...props}>
          <rect x="4" y="48" width="56" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="4" y="20" width="56" height="28" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <circle cx="14" cy="34" r="10" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <circle cx="14" cy="34" r="5" fill="#fff" stroke={c} strokeWidth="1.5"/>
          <rect x="24" y="32" width="14" height="4" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <rect x="38" y="6" width="6" height="22" fill={c}/>
          <circle cx="41" cy="32" r="4" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <polygon points="48,28 56,32 48,36" fill="#7c3aed"/>
        </svg>
      );
    case 'MC':
      // Generic Machining Center — column with vertical spindle
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="10" y="38" width="44" height="10" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <rect x="44" y="10" width="12" height="38" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
          <rect x="28" y="14" width="20" height="8" fill={c}/>
          <rect x="32" y="22" width="6" height="14" fill="#9ca3af" stroke={c} strokeWidth="1"/>
          <circle cx="35" cy="38" r="2" fill={c}/>
        </svg>
      );
    case 'INSPECTION':
      // CMM-like probe
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="10" y="42" width="44" height="6" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <line x1="14" y1="10" x2="14" y2="42" stroke={c} strokeWidth="2"/>
          <line x1="50" y1="10" x2="50" y2="42" stroke={c} strokeWidth="2"/>
          <line x1="14" y1="14" x2="50" y2="14" stroke={c} strokeWidth="2"/>
          <line x1="32" y1="14" x2="32" y2="34" stroke={c} strokeWidth="2"/>
          <circle cx="32" cy="36" r="3" fill="#dc2626"/>
        </svg>
      );
    case 'DEBURRING':
      // Hand deburr tool / brush
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="14" y="32" width="36" height="16" fill="#f9fafb" stroke={c} strokeWidth="1.5"/>
          <circle cx="32" cy="28" r="10" fill="#f59e0b" opacity="0.7"/>
          <g stroke={c} strokeWidth="1">
            {Array.from({length:12}).map((_,i)=>{const a=i*30*Math.PI/180; return <line key={i} x1={32+Math.cos(a)*10} y1={28+Math.sin(a)*10} x2={32+Math.cos(a)*16} y2={28+Math.sin(a)*16}/>;})}
          </g>
        </svg>
      );
    case 'ASSEMBLY':
      // Two parts joined with bolts
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="10" y="24" width="20" height="24" fill="#16a34a" opacity="0.3" stroke={c} strokeWidth="1.5"/>
          <rect x="34" y="24" width="20" height="24" fill="#16a34a" opacity="0.5" stroke={c} strokeWidth="1.5"/>
          <circle cx="22" cy="30" r="2" fill={c}/>
          <circle cx="22" cy="42" r="2" fill={c}/>
          <circle cx="42" cy="30" r="2" fill={c}/>
          <circle cx="42" cy="42" r="2" fill={c}/>
          <line x1="30" y1="36" x2="36" y2="36" stroke={c} strokeWidth="2"/>
        </svg>
      );
    case 'PACKING':
      // Box with tape lines
      return (
        <svg {...props}>
          <polygon points="10,20 32,10 54,20 54,52 32,62 10,52" fill="#d4a574" stroke={c} strokeWidth="1.5"/>
          <line x1="10" y1="20" x2="32" y2="32" stroke={c} strokeWidth="1.5"/>
          <line x1="54" y1="20" x2="32" y2="32" stroke={c} strokeWidth="1.5"/>
          <line x1="32" y1="32" x2="32" y2="62" stroke={c} strokeWidth="1.5"/>
          <rect x="22" y="14" width="20" height="4" fill="#fff" opacity="0.7"/>
        </svg>
      );
    case 'SPECIAL_PROCESS':
      // Furnace / oven for heat treat
      return (
        <svg {...props}>
          <rect x="6" y="48" width="52" height="10" rx="1" fill="#e5e7eb" stroke={c} strokeWidth="1.5"/>
          <rect x="10" y="10" width="44" height="38" fill="#dc2626" opacity="0.2" stroke={c} strokeWidth="1.5"/>
          <rect x="20" y="20" width="24" height="22" fill="#dc2626" opacity="0.6"/>
          <path d="M22 38 Q24 32 26 38 T30 38 T34 38 T38 38 T42 38" stroke="#fff" strokeWidth="1.5" fill="none"/>
          <circle cx="14" cy="16" r="1.5" fill={c}/>
          <circle cx="50" cy="16" r="1.5" fill={c}/>
        </svg>
      );
    default:
      // Generic box
      return (
        <svg {...props}>
          <rect x="8" y="8" width="48" height="48" rx="4" fill="#f3f4f6" stroke={c} strokeWidth="1.5"/>
          <circle cx="32" cy="32" r="10" fill="#cbd5e1" stroke={c} strokeWidth="1.5"/>
        </svg>
      );
  }
}

// For shops without a per-machine type (Deburring, Inspection, etc.)
// look up the shop_type to drive the icon.
export function iconForMachine({ name, shopType }) {
  // Use machine name first
  if (name) {
    const u = String(name).toUpperCase();
    if (u.includes('TMC')) return 'TMC';
    if (u.includes('VMC')) return 'VMC';
    if (u.includes('HMC')) return 'HMC';
    if (u.includes('VTL')) return 'VTL';
    if (u.includes('TC'))  return 'TC';
    if (u.includes('MC'))  return 'MC';
  }
  // Fall back to shop
  if (shopType === 'INSPECTION') return 'INSPECTION';
  if (shopType === 'DEBURRING') return 'DEBURRING';
  if (shopType === 'ASSEMBLY') return 'ASSEMBLY';
  if (shopType === 'PACKING') return 'PACKING';
  if (shopType === 'SPECIAL_PROCESS') return 'SPECIAL_PROCESS';
  return 'OTHER';
}
